export interface ILayoutResourceStrings {
    activeVisitation: string;
    name: string;
    phoneNumber: string;
    companyName: string;
    visitationReason: string;
    vehicleRegistrationNumber: string;
    from: string;
    hasKey: string;
    yes: string;
    no: string;
    email: string;
    comment: string;
    endVisitation: string;
    contextText: string;
    buttonText: string;
    cancelText: string;
    keyText: string;
    notFound: string;
}

export interface ILayoutResources {
    [key: string]: ILayoutResourceStrings;
}

const engb = "en-GB";
const etee = "et-EE";
const ruru = "ru-RU";

export const VisitationStatusTranslations: ILayoutResources = {
    [engb]: {
        activeVisitation: "Active visitation",
        name: "Name",
        phoneNumber: "Phone number",
        companyName: "Company name",
        visitationReason: "Visitation reason",
        vehicleRegistrationNumber: "Vehicle registration number",
        from: "From",
        hasKey: "Has key?",
        yes: "Yes",
        no: "No",
        email: "E-mail",
        comment: "Comment",
        endVisitation: "End visitation",
        contextText: "Are you sure that you want to finish the visitation?",
        buttonText: "Yes",
        cancelText: "Cancel",
        keyText: "Did you return the key?",
        notFound: "Could not retrieve visitation data."
    },
    [ruru]: {
        activeVisitation: "Активное посещение",
        name: "Имя",
        phoneNumber: "Номер телефона",
        companyName: "Компания",
        visitationReason: "Цель визита",
        vehicleRegistrationNumber: "Регистр автомобиля номер",
        from: "От",
        hasKey: "Ключ получен?",
        yes: "Да",
        no: "Нет",
        email: "е-мейл",
        comment: "Комментарий",
        endVisitation: "Завершить посещение",
        contextText: "Вы уверены, что хотите завершить визит?",
        buttonText: "Да",
        cancelText: "Отмена",
        keyText: "Ты вернул ключ?",
        notFound: "Не удалось получить данные о посещениях."
    },
    [etee]: {
        activeVisitation: "Aktiivne külastus",
        name: "Nimi",
        phoneNumber: "Telefoni nr.",
        companyName: "Ettevõtte nimi",
        visitationReason: "Külastuse põhjus",
        vehicleRegistrationNumber: "Auto reg. nr",
        from: "Alates",
        hasKey: "Sain võtme?",
        yes: "Jah",
        no: "Ei",
        email: "E-mail",
        comment: "Kommentaar",
        endVisitation: "Lõpeta külastus",
        contextText: "Oled kindel, et soovid külastust lõpetada?",
        buttonText: "Lõpeta",
        cancelText: "Tühista",
        keyText: "Kas võtme tagastasid?",
        notFound: "Ei leidnud külastuse andmeid."
    }
};

export default VisitationStatusTranslations;
